import allowed from '@/core/constants/allowed-roles.constant'

const routes = [
  {
    name: 'consultant-visit-app',
    path: '/consultant-companion',
    component: () =>
      import(
        '@/modules/consultant-visit-app/containers/consultant-visit-root/consultant-visit-root.vue'
      ),
    meta: {
      requiresAuth: true,
      allowedRoles: [...allowed.consultant_visit.roles],
      layout: 'home',
      allowedModule: 'consultant-companion',
      module: 'consultant-visit-app',
      breadcrumb: {
        label: 'core.menu.modules.consultant-site-visit',
        route: 'consultant-visit-home',
      },
    },
    children: [
      {
        path: '',
        name: 'consultant-visit-home',
        component: () =>
          import(
            '@/modules/consultant-visit-app/containers/consultant-visit/consultant-visit.container.vue'
          ),
      },
      {
        path: 'consultant-visit-projects/:tenantId',
        meta: {
          breadcrumb: {
            label: 'consultant-visit.projects',
            route: 'consultant-visit-home',
          },
        },
        children: [
          {
            path: 'sites/:projectId',
            meta: {
              breadcrumb: {
                label: 'consultant-visit.sites',
                route: 'consultant-visit-sites',
              },
            },
            children: [
              {
                path: '',
                name: 'consultant-visit-sites',
                component: () =>
                  import(
                    '@/modules/consultant-visit-app/containers/consultant-visit-sites/consultant-visit-sites.container.vue'
                  ),
              },
              {
                path: 'tasks/:siteId/:tabId',
                meta: {
                  breadcrumb: {
                    label: 'consultant-visit.tasks',
                    route: 'consultant-visit-tasks',
                  },
                },
                children: [
                  {
                    path: '',
                    name: 'consultant-visit-tasks',
                    component: () =>
                      import(
                        '@/modules/consultant-visit-app/containers/consultant-visit-tasks/consultant-visit-tasks.container.vue'
                      ),
                  },
                ],
              },
              {
                path: 'checklists/:siteId',
                meta: {
                  breadcrumb: {
                    label: 'consultant-visit.checklists',
                    route: 'consultant-visit-checklists',
                  },
                },
                children: [
                  {
                    path: '',
                    name: 'consultant-visit-checklists',
                    component: () =>
                      import(
                        '@/modules/consultant-visit-app/containers/consultant-visit-checklists/consultant-visit-checklists.container.vue'
                      ),
                  },
                  {
                    path: 'review/:checklistId',
                    meta: {
                      breadcrumb: {
                        label: 'consultant-visit.checklist-review',
                        route: 'consultant-visit-checklist-review',
                      },
                    },
                    children: [
                      {
                        path: '',
                        name: 'consultant-visit-checklist-review',
                        component: () =>
                          import(
                            '@/modules/consultant-visit-app/containers/consultant-visit-checklist-review/consultant-visit-checklist-review.container.vue'
                          ),
                      },
                      {
                        path: 'reply',
                        name: 'consultant-visit-checklist-reply',
                        meta: {
                          breadcrumb: {
                            label: 'consultant-visit.checklist-reply',
                            route: 'consultant-visit-checklist-reply',
                          },
                        },
                        component: () =>
                          import(
                            '@/modules/consultant-visit-app/containers/consultant-visit-checklist-reply/consultant-visit-checklist-reply.container.vue'
                          ),
                      },
                    ],
                  },
                ],
              },
              {
                path: 'focus-group-interviews/:siteId',
                meta: {
                  breadcrumb: {
                    label: 'consultant-visit.focus-group-interviews',
                    route: 'consultant-visit-focus-group-interviews',
                  },
                },
                children: [
                  {
                    path: '',
                    name: 'consultant-visit-focus-group-interviews',
                    component: () =>
                      import(
                        '@/modules/consultant-visit-app/containers/focus-group-interviews/focus-group-interviews.container.vue'
                      ),
                  },
                ],
              },
              {
                path: 'documents-evidences/:siteId',
                meta: {
                  breadcrumb: {
                    label: 'consultant-visit.documents-and-evidence',
                    route: 'consultant-visit-documents-evidences',
                  },
                },
                children: [
                  {
                    path: '',
                    name: 'consultant-visit-documents-evidences',
                    component: () =>
                      import(
                        '@/modules/consultant-visit-app/containers/documents-evidences/documents-evidences.container.vue'
                      ),
                  },
                ],
              },
              {
                path: 'progress-dashboard/:siteId',
                meta: {
                  breadcrumb: {
                    label: 'consultant-visit.progress-dashboard',
                    route: 'consultant-visit-progress-dashboard',
                  },
                },
                children: [
                  {
                    path: '',
                    name: 'consultant-visit-progress-dashboard',
                    component: () =>
                      import(
                        '@/modules/consultant-visit-app/containers/consultant-visit-progress-dashboard/consultant-visit-progress-dashboard.container.vue'
                      ),
                  },
                ],
              },
              {
                path: 'assessment-summary',
                meta: {
                  breadcrumb: {
                    label: 'consultant-visit.assessment-summary',
                    route: 'consultant-visit-assessment-summary',
                  },
                },
                children: [
                  {
                    path: '',
                    name: 'consultant-visit-assessment-summary',
                    component: () =>
                      import(
                        '@/modules/consultant-visit-app/containers/consultant-visit-assessment-summary/consultant-visit-assessment-summary.container.vue'
                      ),
                  },
                ],
              },
              {
                path: 'dilo-analysis/:siteId',
                meta: {
                  breadcrumb: {
                    label: 'consultant-visit.dilo-analysis',
                    route: 'consultant-visit-dilo-analysis',
                  },
                },
                children: [
                  {
                    path: '',
                    name: 'consultant-visit-dilo-analysis',
                    component: () =>
                      import(
                        '@/modules/consultant-visit-app/containers/consultant-visit-dilo-analysis/consultant-visit-dilo-analysis.container.vue'
                      ),
                  },
                  {
                    path: 'detail/:diloAnalysisId',
                    meta: {
                      breadcrumb: {
                        label: 'consultant-visit.dilo-analysis',
                        route: 'consultant-visit-dilo-analysis',
                      },
                    },
                    children: [
                      {
                        path: '',
                        name: 'consultant-visit-dilo-analysis-detail',
                        component: () =>
                          import(
                            '@/modules/consultant-visit-app/containers/consultant-visit-dilo-analysis-detail/consultant-visit-dilo-analysis-detail.container.vue'
                          ),
                      },
                    ],
                  },
                  {
                    path: 'wizard/:diloAnalysisId/:stepId?',
                    name: 'consultant-visit-dilo-wizard',
                    meta: {
                      breadcrumb: {
                        label: 'consultant-visit.dilo-analysis',
                        route: 'consultant-visit-dilo-analysis',
                      },
                    },
                    component: () =>
                      import(
                        '@/modules/consultant-visit-app/containers/consultant-visit-dilo-wizard/consultant-visit-dilo-wizard.container.vue'
                      ),
                  },
                ],
              },
              {
                path: 'data-analysis',
                meta: {
                  breadcrumb: {
                    label: 'consultant-visit.data-analysis',
                    route: 'consultant-visit-data-analysis',
                  },
                },
                children: [
                  {
                    path: '',
                    name: 'consultant-visit-data-analysis',
                    component: () =>
                      import(
                        '@/modules/consultant-visit-app/containers/consultant-visit-data-analysis/consultant-visit-data-analysis.container.vue'
                      ),
                  },
                ],
              },
              {
                path: 'assessment-analysis',
                meta: {
                  allowedRoles: allowed.consultant_visit.companionDashboards,
                  allowedModule: 'consultant-companion',
                  fallbackRoute: 'consultant-visit-data-analysis',
                  breadcrumb: {
                    label: 'consultant-visit.assessment-summary',
                    route: 'consultant-visit-assessment-analysis',
                  },
                },
                children: [
                  {
                    path: '',
                    name: 'consultant-visit-assessment-analysis',
                    component: () =>
                      import(
                        '@/modules/consultant-visit-app/containers/consultant-visit-assessment-analysis/consultant-visit-assessment-analysis.container.vue'
                      ),
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'project-forbidden',
        name: 'consultant-visit-project-forbidden',
        component: () =>
          import(
            '@/modules/consultant-visit-app/containers/cva-project-forbidden/cva-project-forbidden.vue'
          ),
      },
      {
        path: 'survey-creator',
        name: 'consultant-visit-survey-creator',
        component: () =>
          import(
            '@/modules/consultant-visit-app/containers/consultant-visit-survey-creator/consultant-visit-survey-creator.container.vue'
          ),
      },
      {
        path: 'survey-creator/:checklistId',
        name: 'consultant-visit-survey-creator-edit',
        component: () =>
          import(
            '@/modules/consultant-visit-app/containers/consultant-visit-survey-creator/consultant-visit-survey-creator.container.vue'
          ),
      },
      {
        path: 'image-inbox/:tenantId?',
        name: 'consultant-visit-image-inbox',
        meta: {
          breadcrumb: {
            label: 'consultant-visit.image-inbox.title',
            route: 'consultant-visit-image-inbox',
          },
        },
        component: () =>
          import(
            '@/modules/consultant-visit-app/containers/cva-image-inbox/cva-image-inbox.container.vue'
          ),
      },
      {
        path: 'dashboards/:tenantId?/:projectId?',
        name: 'consultant-visit-dashboards',
        meta: {
          allowedRoles: allowed.consultant_visit.companionDashboards,
          allowedModule: 'consultant-companion',
          fallbackRoute: 'consultant-visit-home',
          breadcrumb: {
            label: 'core.menu.modules.dashboards',
            route: 'consultant-visit-dashboards',
          },
        },
        component: () =>
          import(
            '@/modules/consultant-visit-app/containers/consultant-visit-assessment-analysis/consultant-visit-assessment-analysis.container.vue'
          ),
      },
    ],
  },
]

export default routes
